import { SwimlaneCriteriaMap } from './swimlane-criteria-map';
import { ITripCardSchema } from './trip-card-schema.interface';

export interface IKanbanColumnsSchema {
    idColumn: string;
    columnName: string;
    total: number;
    totalDelays: SwimlaneCriteriaMap<number>;
    totalNotReporting: SwimlaneCriteriaMap<number>;
    totalNotDelayed: SwimlaneCriteriaMap<number>;
    tripCards: ITripCardSchema[];
}

export interface Columns {
    finished: IKanbanColumnsSchema;
    pending: IKanbanColumnsSchema;
    board: IKanbanColumnsSchema[];
}

export interface MetaResponse {
    total: number;
    page: number;
    totalPages: number;
    limit: number;
}

export interface IColumnsStateDefinition {
    data: Columns;
    meta: MetaResponse;
}
